import React, { useState, useEffect } from "react";
import { Tabs, Spin, Row, Card, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchEnrollmentPolicyType } from "../../Action/Actions";
import { selectSelectedYearId, selectFinancialYears } from "../../Redux/financialYearSlice";
import { getUserData } from "../login/LoginSlice";
import IpdForm from "./IpdForm";
import OpdForm from "./OpdForm";
import { TeamOutlined, UserOutlined, FireOutlined, FileAddOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";


const IntimateClaim = () => {
  const dispatch = useDispatch();
  const AuthData = useSelector(getUserData);
  const selectedYearId = useSelector(selectSelectedYearId);
  const financialYears = useSelector(selectFinancialYears);
  const selectedYear = financialYears.find(year => year.id === selectedYearId)?.financial_year || "Not Selected";
  
  console.log("AuthData:", AuthData);
  console.log("User Data:", AuthData?.user_data);
  const [activeTab, setActiveTab] = useState("");
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
  const [selectedRefPolicyId, setSelectedRefPolicyId] = useState(null);
  const [policyData, setPolicyData] = useState({});
  const [loading, setLoading] = useState(false);
  const policyTypes = Object.keys(policyData || {});
  const user = useSelector(getUserData);
  const location = useLocation();
  const { employeeCode, employeeName } = location.state || {};

  useEffect(() => {
    const fetchPolicyData = async () => {
      if (!AuthData?.corporate_id || !selectedYearId) {
        setLoading(false);
        setPolicyData({});
        setSelectedPolicyNumber(null);
        setSelectedRefPolicyId(null);
        return;
      }
      try {
        setLoading(true);
        const data = await dispatch(fetchEnrollmentPolicyType(AuthData?.corporate_id));
        console.log("Fetched Policy Data:", data);
        const { policy_type_list } = data;
        
        setPolicyData(policy_type_list || {});
        
        // Get policy types that actually have data (not empty arrays)
        const availableTabs = Object.keys(policy_type_list || {}).filter(
          (tab) => policy_type_list[tab] && policy_type_list[tab].length > 0
        );
        
        // Use the first available type that has data
        const tabToUse = availableTabs.length > 0 ? availableTabs[0] : "";
        
        // Update activeTab to the first available type with data
        if (tabToUse && tabToUse !== activeTab) {
          setActiveTab(tabToUse);
        }
        
        // Set the first policy for the active tab
        const firstPolicy = policy_type_list[tabToUse]?.[0];
        if (firstPolicy) {
          // Use the same logic: policy_number if available, otherwise policy_id
          const policyNumber = firstPolicy?.policy_number?.trim() || firstPolicy?.policy_id;
          setSelectedPolicyNumber(policyNumber || null);
          setSelectedRefPolicyId(firstPolicy?.policy_id || null);
        }
      } catch (err) {
        console.error("Error fetching policy data:", err);
        setPolicyData({});
        setSelectedPolicyNumber(null);
        setSelectedRefPolicyId(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, AuthData?.corporate_id, selectedYearId]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    const firstPolicy = policyData[key]?.[0];
    if (firstPolicy) {
      // Use the same logic: policy_number if available, otherwise policy_id
      const policyNumber = firstPolicy?.policy_number?.trim() || firstPolicy?.policy_id;
      setSelectedPolicyNumber(policyNumber || null);
      setSelectedRefPolicyId(firstPolicy?.policy_id || null);
      console.log("Active Tab Changed:", key);
      console.log("Selected Policy Number:", policyNumber);
    } else {
      setSelectedPolicyNumber(null);
      setSelectedRefPolicyId(null);
    }
  };

  const handlePolicyNumberClick = (policyKey) => {
    // policyKey is already normalized (policy_number or policy_id)
    setSelectedPolicyNumber(policyKey);
    
    // Find the policy to get its ID
    const selectedPolicy = policyData[activeTab]?.find(policy => {
      const key = policy.policy_number?.trim() || policy.policy_id;
      return key === policyKey;
    });
    setSelectedRefPolicyId(selectedPolicy?.policy_id || null);
    console.log("Policy Number Clicked:", policyKey);
  };

  const getTabIcon = (type) => {
    switch (type) {
      case "GMC":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "GTL":
        return <UserOutlined style={{ marginRight: 8 }} />;
      case "GPA":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Parent policy":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Topup":
        return <FileAddOutlined style={{ marginRight: 8 }} />;
      case "Fire":
        return <FireOutlined style={{ marginRight: 8 }} />;
      default:
        return null;
    }
  };

  const renderDocuments = (documents) => {
    if (documents && documents.length > 0) {
      return (
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Intimate IPD (Hospitalisation)" key="1">
            <IpdForm selectedPolicyNumber={selectedPolicyNumber} refPolicyId={selectedRefPolicyId}
             initialEmployeeCode={employeeCode}
             initialEmployeeName={employeeName} />
           
          </Tabs.TabPane>
          <Tabs.TabPane tab="Intimate OPD (Domiciliary)" key="2">
            <OpdForm selectedPolicyNumber={selectedPolicyNumber} refPolicyId={selectedRefPolicyId} 
             initialEmployeeCode={employeeCode}
             initialEmployeeName={employeeName} />
          </Tabs.TabPane>
        </Tabs>
      );
    } else {
      return (
        <div className="escalation-message">
          No documents found for this policy.
        </div>
      );
    }
  };

  const tabItems = policyTypes.map((type) => ({
    key: type,
    label: (
      <>
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {type}
          {getTabIcon(type)}
        </span>
      </>
    ),
    children: (
      <>
        <Tabs
          activeKey={selectedPolicyNumber}
          onChange={handlePolicyNumberClick}
          items={policyData[type]?.map((policy) => {
            // Use the same logic: policy_number if available, otherwise policy_id
            const key = policy.policy_number?.trim() || policy.policy_id;
            return {
              key: key,
              label: policy.policy_number?.trim() ? (
                policy.policy_number.trim()
              ) : (
                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  
                  <Tag
                    style={{
                      backgroundColor: "#FFFF00",
                      color: "#000000E0",
                      fontSize: "12px",
                      padding: "2px 8px",
                      margin: 0,
                      fontFamily: '"Plus Jakarta Sans", sans-serif',
                      borderRadius: "4px",
                    }}
                  >
                    Policy Number not issued
                  </Tag>
                </span>
              ),
            };
          })}
        />
        {selectedPolicyNumber
          ? renderDocuments(
              policyData[type]?.filter(
                (doc) => {
                  const key = doc.policy_number?.trim() || doc.policy_id;
                  return key === selectedPolicyNumber;
                }
              ) || []
            )
          : renderDocuments([])}
      </>
    ),
  }));

  return (
    <Spin spinning={loading}>
      <div className="escalation-matrix-container">
        <div className="escalation-content">
          <Row className="escalation-row-header">
          <span style={{ fontWeight: "700", fontSize: "20px" }}>
            {user?.corporate_name || "Guest"}
            </span>{" "}
            <span style={{ marginLeft: "8px" }}>
              (Financial Year: {selectedYear})
            </span>
          </Row>
        </div>
        {policyTypes.length > 0 ? (
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            className="esc-tab"
            items={tabItems}
          />
        ) : (
          <Card style={{ marginTop: "20px" }}>
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              <p style={{ fontSize: "16px", fontWeight: "500" }}>No intimate claim data available for {selectedYear}</p>
            </div>
          </Card>
        )}
      </div>
    </Spin>
  );
};

export default IntimateClaim;
